import script from "./Interim1.vue?vue&type=script&lang=ts&setup=true"
export * from "./Interim1.vue?vue&type=script&lang=ts&setup=true"

import "./Interim1.vue?vue&type=style&index=0&id=fea944c4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fea944c4"]])

export default __exports__